import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SplashScreenComponent } from './splash-screen/splash-screen.component'
import { ConfirmModalComponent } from './confirm-modal/confirm-modal'
import { NotifyModalComponent } from './notify-modal/notify-modal'
import { DateWithoutTime } from './date-without-time.pipe'
import { TextCounterComponent } from './text-counter/text-counter.component'
import { DateTimeWithTimeZone } from './date-time-with-timezone.pipe'
import { AppSelectComponent } from './app-select/app-select.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { FormsModule } from '@angular/forms'
import { GridWrapperComponent } from './grid-wrapper/grid-wrapper.component'
import { NgBusyModule } from 'ng-busy'
import { AgGridModule } from 'ag-grid-angular'
import { RouterModule } from '@angular/router'
import { ActionButtonsColumnRendererComponent } from './grid-wrapper/columns/action-buttons-column.renderer.component'
import { ChangeValueActionRendererComponent } from './grid-wrapper/columns/change-value-action.renderer.component'
import { DateColumnRendererComponent } from './grid-wrapper/columns/date-column.renderer.component'
import { DateTimeColumnRendererComponent } from './grid-wrapper/columns/date-time-column.renderer.component'
import { LinkColumnRendererComponent } from './grid-wrapper/columns/link-column.renderer.component'
import { MoveButtonsColumnRendererComponent } from './grid-wrapper/columns/move-buttons-column.renderer.component'
import { RiskScoresColumnRendererComponent } from './grid-wrapper/columns/risk-scores-column.renderer.component'
import { TimeColumnRendererComponent } from './grid-wrapper/columns/time-column.renderer.component'
import { TooltipColumnRendererComponent } from './grid-wrapper/columns/tooltip-column.renderer.component'
import { ViewButtonColumnRendererComponent } from './grid-wrapper/columns/view-button-column.renderer.component'
import { LookupFilterComponent } from './grid-wrapper/filters/lookup-filter/lookup-filter.component'
import { BooleanFilterComponent } from './grid-wrapper/filters/boolean-filter.component'
import { HasAssessmentFilterComponent } from './grid-wrapper/filters/has-assessment-filter.component'
import { HighPriorityFilterComponent } from './grid-wrapper/filters/high-priority-filter.component'
import { ContainsLookupFilterComponent } from './grid-wrapper/filters/contains-lookup-filter.component'
import { MultiLookupFilterComponent } from './grid-wrapper/filters/multilookup-filter/multilookup-filter.component'
import { NullNotNullFilterComponent } from './grid-wrapper/filters/nullnotnull-filter.component'
import { UploadComponent } from './upload/upload.component'
import { FileUploadModule } from 'ng2-file-upload'

@NgModule({
  declarations: [
    SplashScreenComponent,
    ConfirmModalComponent,
    NotifyModalComponent,
    DateWithoutTime,
    DateTimeWithTimeZone,
    TextCounterComponent,
    AppSelectComponent,
    GridWrapperComponent,
    ActionButtonsColumnRendererComponent,
    ChangeValueActionRendererComponent,
    DateColumnRendererComponent,
    DateTimeColumnRendererComponent,
    LinkColumnRendererComponent,
    MoveButtonsColumnRendererComponent,
    RiskScoresColumnRendererComponent,
    TimeColumnRendererComponent,
    TooltipColumnRendererComponent,
    ViewButtonColumnRendererComponent,
    LookupFilterComponent,
    BooleanFilterComponent,
    HasAssessmentFilterComponent,
    HighPriorityFilterComponent,
    ContainsLookupFilterComponent,
    MultiLookupFilterComponent,
    NullNotNullFilterComponent,
    UploadComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    NgSelectModule,
    FormsModule,
    NgBusyModule,
    AgGridModule,
    FileUploadModule
  ],
  exports: [
    SplashScreenComponent,
    ConfirmModalComponent,
    NotifyModalComponent,
    DateWithoutTime,
    DateTimeWithTimeZone,
    TextCounterComponent,
    AppSelectComponent,
    GridWrapperComponent,
    ActionButtonsColumnRendererComponent,
    ChangeValueActionRendererComponent,
    DateColumnRendererComponent,
    DateTimeColumnRendererComponent,
    LinkColumnRendererComponent,
    MoveButtonsColumnRendererComponent,
    RiskScoresColumnRendererComponent,
    TimeColumnRendererComponent,
    TooltipColumnRendererComponent,
    ViewButtonColumnRendererComponent,
    LookupFilterComponent,
    BooleanFilterComponent,
    HasAssessmentFilterComponent,
    HighPriorityFilterComponent,
    MultiLookupFilterComponent,
    NullNotNullFilterComponent,
    UploadComponent,
    ContainsLookupFilterComponent
  ]
})
export class CommonComponentsModule {}
